import { render } from "./Organization.vue?vue&type=template&id=c680468e&ts=true"
import script from "./Organization.vue?vue&type=script&lang=ts"
export * from "./Organization.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__